/** Copyright 2025 Midas Healthcare Solutions - All Rights Reserved **/
import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GeneralSettings, SettingsGroups, UiActions, UiSelectors, UiTheme } from '@midas/shared/common';
import { UserActions, UserSelectors } from '@midas/shared/data-access';
import { Store } from '@ngrx/store';
import { map, take } from 'rxjs';

@Component({
  selector: 'midas-ui-theme-toggle',
  templateUrl: './ui-theme-toggle.component.html',
  styleUrls: ['./ui-theme-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, AsyncPipe, MatButtonModule, MatIconModule, MatTooltipModule],
})
export class UiThemeToggleComponent {
  readonly theme$ = this.store.select(UiSelectors.getUiState).pipe(map((state) => state.theme));

  constructor(private store: Store) {}

  setTheme(currentTheme: UiTheme) {
    const theme = currentTheme === 'dark' ? 'light' : 'dark';
    this.store.dispatch(UiActions.setTheme({ theme }));

    this.store
      .select(UserSelectors.getUserState)
      .pipe(take(1))
      .subscribe((u) => {
        if (u && u.loaded) {
          this.store.dispatch(
            UserActions.updateUserAlibiSettings({
              settingsGroup: SettingsGroups.GeneralSettings,
              settingsJson: JSON.stringify({ [GeneralSettings.UITheme]: theme }),
            }),
          );
        }
      });
  }
}
